import React from "react"
// import type { GatsbyBrowser } from "gatsby"
import "@fontsource/zen-kaku-gothic-new"
import "@fontsource/zen-kaku-gothic-new/500.css"
import "@fontsource/zen-kaku-gothic-new/700.css"
import "./src/global.css"

import { RubyVisibleStateProvider } from "./src/context/RubyVisibleStateContext"

export const wrapRootElement = ({ element }) => {
  return (
    <RubyVisibleStateProvider>{element}</RubyVisibleStateProvider>
  )
}